import { atom } from 'jotai'
import { MultiSelection } from 'sierra-client/views/flexible-content/editor/content-sidebar/multi-selection/types'

export const multiSelectionAtom = atom<MultiSelection>({})

/* Defines which actions will not clear the multiselection */
export const isAbortingMultiSelectionClearAtom = atom<boolean>(false)
